import { EpochEnum } from '@acme/api/admin';
import { twMerge } from 'tailwind-merge';

const MAX_STEPS = 4;

type ColorType = {
  bg: string;
  text: string;
};

type EpochConfig = ColorType & { steps: number };

const epochConfig: { [key in EpochEnum]?: EpochConfig } = {
  [EpochEnum.ChangesRequired]: {
    bg: 'bg-red-500',
    text: 'text-red-500',
    steps: 1,
  },
  [EpochEnum.Confirmed]: {
    bg: 'bg-green-900',
    text: 'text-green-900',
    steps: 2,
  },
  [EpochEnum.ReviewAdmin]: {
    bg: 'bg-yellow-400',
    text: 'text-yellow-400',
    steps: 3,
  },
  [EpochEnum.Review]: {
    bg: 'bg-gray-700',
    text: 'text-gray-700',
    steps: 3,
  },
  [EpochEnum.New]: {
    bg: 'bg-gray-700',
    text: 'text-gray-700',
    steps: 1,
  },
  [EpochEnum.Draft]: {
    bg: 'bg-gray-500',
    text: 'text-gray-500',
    steps: 1,
  },
  [EpochEnum.InProgress]: {
    bg: 'bg-primary-500',
    text: 'text-primary-500',
    steps: 3,
  },
  [EpochEnum.Rejected]: {
    bg: 'bg-red-500',
    text: 'text-red-500',
    steps: 0,
  },
  [EpochEnum.Completed]: {
    bg: 'bg-purple-900',
    text: 'text-purple-900',
    steps: 4,
  },
  [EpochEnum.Accomplished]: {
    bg: 'bg-purple-900',
    text: 'text-purple-900',
    steps: 4,
  },
};

const defaultConfig: EpochConfig = {
  bg: 'bg-gray-700',
  text: 'text-gray-700',
  steps: 3,
};

const getEpochConfig = (id?: EpochEnum | null): EpochConfig => {
  if (!id) return defaultConfig;
  const cfg = epochConfig[id];
  if (!cfg) return defaultConfig;
  return {
    ...cfg,
    steps: Math.min(MAX_STEPS, Math.max(0, cfg.steps)),
  };
};

export const ApplicationEpoch = ({
  epoch,
  hint,
}: {
  epoch?: { id?: EpochEnum | null; name?: string | null } | null;
  hint?: string | null;
}) => {
  const config = getEpochConfig(epoch?.id);
  const steps = Array.from({ length: config.steps }, (_, i) => i);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-2.5 w-[212px]">
          <div className="flex items-center gap-1.5">
            <div
              className={twMerge(
                'w-3 h-3 rounded-full flex-shrink-0',
                config.bg
              )}
            />
            <span
              className={twMerge(
                'text-sm font-medium leading-[14px]',
                config.text
              )}
            >
              {epoch?.name || 'Новая заявка'}
            </span>
          </div>
          <div className="grid grid-cols-4 items-center gap-1 w-full min-h-1">
            {config.steps > 0
              ? steps.map((i) => (
                  <div
                    key={i}
                    className={twMerge(
                      'flex-1 h-1 bg-gray-200 rounded-sm',
                      config.bg
                    )}
                  />
                ))
              : null}
          </div>
        </div>
      </div>

      {hint ? (
        <div className="flex items-center gap-2 text-sm text-gray-500">
          {hint}
        </div>
      ) : null}
    </div>
  );
};
